import { __rest } from "tslib";
import React, { useLayoutEffect, useRef } from 'react';
import { default as getAttributesForPIIMasking } from "@pb/utils/common/getAttributesForPIIMasking";
import cn from 'classnames';
import { PinOutlineIcon, HMLogoIcon } from "../../../ui/Icon";
import styles from './SuggestionItem.module.scss';
const icons = {
    PinOutlineIcon,
    HMLogoIcon,
};
const SuggestionItem = (_a) => {
    var { isActive, index, id, onSuggestionClick, children, icon = 'PinOutlineIcon' } = _a, props = __rest(_a, ["isActive", "index", "id", "onSuggestionClick", "children", "icon"]);
    const itemRef = useRef(null);
    const IconComp = icons[icon];
    useLayoutEffect(() => {
        if (itemRef.current && isActive) {
            itemRef.current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
    }, [isActive]);
    return (React.createElement("li", Object.assign({ role: "option", "aria-selected": isActive, id: id, ref: itemRef }, (isActive && { 'data-testid': 'selectedOption' }), props),
        React.createElement("button", Object.assign({ type: "button", className: cn(styles.suggestion, isActive && styles.active), onClick: () => onSuggestionClick(index), tabIndex: -1 }, getAttributesForPIIMasking()),
            IconComp && React.createElement(IconComp, { className: styles.icon }),
            children)));
};
export default SuggestionItem;
//# sourceMappingURL=SuggestionItem.js.map